import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { PERFECT_LOOK_OPTIONS } from '@/pages/Onboarding/options/PerfectLook/PERFECT_LOOK_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenPerfectLook: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'PerfectLook',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const perfectLook = form.watch('perfect_look');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['perfect_look']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        perfectLook: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>What does your perfect trans girl look like?</OwnAiTitle>
        <OnboardingOptionsList>
          {PERFECT_LOOK_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={perfectLook === option.id}
              control={form.control}
              option={option}
              name="perfect_look"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`perfect-look-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
